/** AR01 copy (one group per control; a ticket edits only its own file). */
export const ar01PtBr = {
  title: 'Cronogramas de reconhecimento',
  description:
    'Contratos, aditivos, renovações e encerramentos com cronograma de reconhecimento válido.',
  prerequisite: 'Requer a avaliação de cobertura dos cronogramas.',
  reasons: {
    MISSING_SCHEDULE: 'Sem cronograma de reconhecimento ativo',
    STALE_SCHEDULE: 'Cronograma ativo de uma versão anterior do contrato',
    INVALID_SCHEDULE_EXCEPTION: 'Pendência financeira aberta no contrato',
    // ALC-4535 fix round 1 item 6: COVERAGE_LIMIT now only fires for a contract whose CURRENT
    // status is encerrado (CANCELLED/EXPIRED) — state only what the code actually knows,
    // never a timing claim about when the cancellation happened relative to the period.
    COVERAGE_LIMIT: 'Contrato encerrado com cronograma cancelado',
  },
  openContract: 'Abrir contrato',
  // Fix round 1b item N6: this link opens the SAME contract page as openContract (there is
  // no separate schedule view) — "Abrir cronograma" implied a destination that doesn't
  // exist.
  openSchedule: 'Ver cronograma no contrato',
  unsupportedCoverageNote:
    'Cobertura parcial: alguns contratos ou itens ainda não são avaliados por este controle.',
  listTruncated: 'Mostrando as primeiras {{shown}} de {{total}} pendências.',
};

export const ar01En: typeof ar01PtBr = {
  title: 'Recognition schedules',
  description:
    'Contracts, amendments, renewals and terminations with a valid recognition schedule.',
  prerequisite: 'Needs the schedule coverage evaluation.',
  reasons: {
    MISSING_SCHEDULE: 'No active recognition schedule',
    STALE_SCHEDULE: 'Active schedule from an earlier contract version',
    INVALID_SCHEDULE_EXCEPTION: 'Open finance exception on the contract',
    COVERAGE_LIMIT: 'Terminated contract with a cancelled schedule',
  },
  openContract: 'Open contract',
  openSchedule: 'View schedule in contract',
  unsupportedCoverageNote:
    'Partial coverage: some contracts or items are not evaluated by this control yet.',
  listTruncated: 'Showing the first {{shown}} of {{total}} open items.',
};
